import React from 'react';
import { useLocation } from 'react-router-dom';
import Button from './ui/Button';
import Icon from './AppIcon';

const ContextualActionBar = ({ 
  onSave, 
  onPreview, 
  onPublish, 
  onExport,
  isSaving = false,
  hasUnsavedChanges = false,
  publishStatus = 'draft'
}) => {
  const location = useLocation();
  const currentPath = location?.pathname;

  const getActions = () => {
    // Используем includes для поддержки новых путей /projects/:id/editor
    if (currentPath?.includes('/editor')) {
      return (
        <>
          <Button
            variant="outline"
            size="default"
            iconName="Save"
            iconPosition="left"
            onClick={onSave}
            loading={isSaving}
            disabled={!hasUnsavedChanges}
          >
            <span className="hidden sm:inline">{isSaving ? 'Saving...' : 'Save'}</span>
          </Button>
          <Button
            variant="secondary"
            size="default"
            iconName="Eye"
            iconPosition="left"
            onClick={onPreview}
          >
            <span className="hidden sm:inline">Preview</span>
          </Button>
          <Button
            variant="outline"
            size="default"
            iconName="Download"
            iconPosition="left"
            onClick={onExport}
          >
            <span className="hidden sm:inline">Export</span>
          </Button>
          <Button
            variant="default"
            size="default"
            iconName="Upload"
            iconPosition="left"
            onClick={onPublish}
          >
            <span className="hidden sm:inline">{publishStatus === 'published' ? 'Update' : 'Publish'}</span>
          </Button>
        </>
      );
    }

    if (currentPath?.includes('/preview')) {
      return (
        <>
          <Button
            variant="outline"
            size="default"
            iconName="ArrowLeft"
            iconPosition="left"
            onClick={() => window.history?.back()}
          >
            <span className="hidden sm:inline">Back to Editor</span>
          </Button>
          <Button
            variant="default"
            size="default"
            iconName="Upload"
            iconPosition="left"
            onClick={onPublish}
          >
            <span className="hidden sm:inline">Publish Site</span>
          </Button>
        </>
      );
    }

    if (currentPath?.includes('/settings')) {
      return (
        <>
          <Button
            variant="outline"
            size="default"
            iconName="Download"
            iconPosition="left"
            onClick={onExport}
          >
            <span className="hidden sm:inline">Export Settings</span>
          </Button>
          <Button
            variant="default"
            size="default"
            iconName="Save"
            iconPosition="left"
            onClick={onSave}
            loading={isSaving}
          >
            <span className="hidden sm:inline">{isSaving ? 'Saving...' : 'Save Changes'}</span>
          </Button>
        </>
      );
    }

    if (currentPath === '/dashboard') {
      return null;
    }

    return null;
  };

  const actions = getActions();

  if (!actions) {
    return null;
  }

  return (
    <div className="contextual-action-bar">
      {hasUnsavedChanges && currentPath?.includes('/editor') && (
        <div className="hidden lg:flex items-center gap-2 mr-4 text-warning">
          <Icon name="AlertCircle" size={16} />
          <span className="caption">Unsaved changes</span>
        </div>
      )}
      {actions}
    </div>
  );
};

export default ContextualActionBar;